module.exports = __webpack_public_path__ + "static/media/10_l_okno_14.79_1.57.36f23046.png";